import React, { useState } from 'react';
import { useUserStore } from '../../../store/userStore';
import TooltipComp from '../../../components/TooltipComp';

interface BadgeType {
  name: string;
  display_name: string;
  current: number;
  total: number;
  hasProgress: boolean;
  earned: boolean;
  image: string;
}

interface UserBadgeProps {
  onlyShowEarned?: boolean;
  tooltipName?: boolean;
  selectedUser?: any;
}

const UserBadge: React.FC<UserBadgeProps> = ({ onlyShowEarned = false, tooltipName = false, selectedUser }) => {
  const user = useUserStore((state) => state.user);
  const [svgContents, setSvgContents] = useState<{ [key: string]: string }>({})

  let filteredBadges = [];
  if (selectedUser) {
    filteredBadges = onlyShowEarned
      ? selectedUser?.badges?.filter((badge: BadgeType) => badge.earned)
      : selectedUser?.badges;
  }
  else {
    filteredBadges = onlyShowEarned
      ? user?.badges?.filter((badge: BadgeType) => badge.earned)
      : user?.badges;
  }


  return (
    <>
      <div className="grid grid-cols-3 text-white md:grid-cols-4 gap-2 mt-4 mb-2 w-full">
        {/* Static Badge */}
        <div key={-1} className="flex flex-col items-center">
          <img
            src={`/badges/stoic icon light on dark round.svg`}
            className="w-10 h-10"
            alt="badge"
          />
          <div className="text-center mt-2" style={{ fontSize: '8px' }}>
            Stoic Novice
          </div>
        </div>
        {filteredBadges
          ?.sort((badgeA: BadgeType, badgeB: BadgeType) => {
            return badgeA.name.localeCompare(badgeB.name);
          })
          .map((badge: BadgeType, index: number) => {
            const userHasBadge = badge.earned;
            const hasProgress = badge.hasProgress;
            const badgeImage = encodeURI(badge.image);
            console.log(badgeImage);

            return (
              <TooltipComp
                key={index}
                text={
                  tooltipName
                    ? badge.display_name
                    : `${badge.display_name}${hasProgress ? ` (Progress: ${badge.current}/${badge.total})` : ''}`
                }
              >
                <div className="flex flex-col items-center">
                  <div className={`${userHasBadge ? 'opacity-100' : 'opacity-30'}`}>
                    <img
                      src={badgeImage}
                      className="w-10 h-10"
                      alt={`${badge.display_name} badge`}
                    />
                  </div>
                  <div className={`text-center text-white mt-2 ${userHasBadge ? 'opacity-100' : 'opacity-30'}`} style={{ fontSize: '8px' }}>
                    {badge.display_name}
                    {hasProgress && !selectedUser && (
                      <div className="text-xs text-gray-400">
                        {badge.current}/{badge.total}
                      </div>
                    )}
                  </div>
                </div>
              </TooltipComp>
            );
          })}
      </div>
    </>
  );
};

export default UserBadge;